/* eslint-disable react/prop-types */

import React, { useContext } from 'react';
import { Container } from './styles';
import { DarkModeContext } from '../../common/contexts/darkMode';

function Card({ children, style }) {
  const { toggleMode } = useContext(DarkModeContext);

  return (
    <Container style={style} darkMode={toggleMode}>
      {children}
    </Container>
  );
}

export default Card;